import React from 'react';
import { DashboardCard } from './DashboardShared';

export interface DashboardSidebarItem {
  key: string;
  label: string;
  icon: React.ReactNode;
  badge?: string | number;
}

interface DashboardSidebarProps {
  items: DashboardSidebarItem[];
  active: string;
  onChange: (key: string) => void;
}

export const DashboardSidebar: React.FC<DashboardSidebarProps> = ({ items, active, onChange }) => {
  return (
    <DashboardCard className="sticky top-36 border-[#DDE5FF] bg-white/95 p-2.5 backdrop-blur">
      <p className="px-2 pb-2 text-[11px] font-extrabold tracking-wide text-slate-400">منوی داشبورد</p>
      <nav className="space-y-1">
        {items.map((item) => {
          const isActive = active === item.key;
          return (
            <button
              key={item.key}
              type="button"
              onClick={() => onChange(item.key)}
              className={`flex w-full items-center justify-between rounded-lg px-2.5 py-2 text-sm font-bold transition ${
                isActive
                  ? 'border border-[#C8D6FF] bg-[#EEF4FF] text-[#1C3B9B]'
                  : 'text-slate-600 hover:bg-slate-100'
              }`}
            >
              <span className="flex items-center gap-2">
                <span className={`${isActive ? 'text-[#1C3B9B]' : 'text-slate-500'}`}>{item.icon}</span>
                <span>{item.label}</span>
              </span>
              {item.badge !== undefined && item.badge !== null && item.badge !== '' ? (
                <span
                  className={`min-w-6 rounded-full px-2 py-0.5 text-center text-[11px] ${
                    isActive ? 'bg-white text-[#1C3B9B]' : 'bg-white text-slate-500'
                  }`}
                >
                  {item.badge}
                </span>
              ) : null}
            </button>
          );
        })}
      </nav>
    </DashboardCard>
  );
};
